import React, { useEffect, useState } from "react";

const MIN_MS = 1100;

export default function BootLoader({ children }) {
  const [phase, setPhase] = useState("boot"); // boot | leave | done

  useEffect(() => {
    const started = performance.now();
    let cancelled = false;

    const finish = () => {
      if (cancelled) return;
      const elapsed = performance.now() - started;
      const wait = Math.max(0, MIN_MS - elapsed);
      window.setTimeout(() => {
        if (!cancelled) setPhase("leave");
      }, wait);
    };

    if (document.fonts?.ready) {
      document.fonts.ready.then(finish).catch(finish);
    } else {
      finish();
    }

    document.documentElement.classList.add("is-booting");
    return () => {
      cancelled = true;
      document.documentElement.classList.remove("is-booting");
    };
  }, []);

  useEffect(() => {
    if (phase !== "leave") return undefined;
    const id = window.setTimeout(() => {
      setPhase("done");
      document.documentElement.classList.remove("is-booting");
    }, 700);
    return () => window.clearTimeout(id);
  }, [phase]);

  return (
    <>
      {phase !== "done" && (
        <div
          className={`boot ${phase === "leave" ? "boot--leave" : ""}`}
          role="status"
          aria-live="polite"
          aria-busy={phase === "boot"}
          aria-label="Loading IT-Patrol"
        >
          <div className="boot__stage">
            <div className="boot__sphere" aria-hidden="true">
              <div className="boot__bands" />
            </div>
            <p className="boot__brand">
              <span>IT</span>
              <span>Patrol</span>
            </p>
            <p className="boot__meta">Initializing systems</p>
          </div>
        </div>
      )}
      <div className={phase === "done" ? "boot-ready" : "boot-ready is-waiting"}>{children}</div>
    </>
  );
}
